export const FREE_ACCESS_MODULE = ['PROFILE', 'PLUGIN'];

export default FREE_ACCESS_MODULE;
